import { APP_INITIALIZER, ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule, SessionRedirectComponent } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MainLayoutContainerModule } from './view/main-layout-container/main-layout-container.module';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { AuthInterceptor } from './core/interceptors/auth/auth.interceptor';
import { MapperModule } from '@dynamic-mapper/angular';
import { MAPPING_PROFILES } from './core/mappings/mapping-profiles';
import { provideFirebaseApp, initializeApp, } from '@angular/fire/app';
import { environment } from 'src/environments/environment';
import { AngularFireModule, } from '@angular/fire/compat';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { IconModule } from './icon.module';
import { PlatformModule } from '@angular/cdk/platform';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { HandleGlobalErrorService } from './core/services/global-error/handle-global-error.service.spec';
import { DataPreloadService } from './core/store/storage/preload.service';
import { SharedContainerModule } from './view/shared-container/shared-container.module';
export function preloadAppData(dataPreloadService: DataPreloadService): () => Promise<void> {
  return () => dataPreloadService.prepare();
}
@NgModule({
  declarations: [
    AppComponent,
    SessionRedirectComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MainLayoutContainerModule,
    HttpClientModule,
    MapperModule.withProfiles([...MAPPING_PROFILES]),
    AngularFireModule.initializeApp(environment.firebase),
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    IconModule,
    MatSnackBarModule,
    PlatformModule,
    ScrollingModule,
    SharedContainerModule
  ],
  providers: [
    {
      provide: LocationStrategy,
      useClass: HashLocationStrategy
    },
    {
      provide: 'Window',
      useValue: window
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    {
      provide: ScrollingModule,
      useValue: {
        momentum: false,
      },
    },
    {
      provide: APP_INITIALIZER,
      useFactory: preloadAppData,
      deps: [DataPreloadService],
      multi: true,
    },
    {
      provide: ErrorHandler,
      useClass: HandleGlobalErrorService // Add Global Error Handler here  
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
